'use strict';

const { h } = require('phy');

const Thumbnail = require('./thumbnail');

const CarouselBase = require('./base');
const Slide = require('./slide');

function getOfferImageSize(isTouch, innerWidth) {
  if (isTouch) {
    return innerWidth ? [`w_${innerWidth},h_136`] : ['w_400,h_136'];
  }

  return ['w_868,h_289'];
}

function getLogoImageSize(isTouch) {
  if (isTouch) {
    return ['w_68,h_68'];
  }

  return ['w_86,h_86'];
}

class CarouselV2 extends CarouselBase {
  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      pageNumber: 0,
      innerWidth: 0,
    };
    this.duration = this.props.duration || 6000;
    this.slidesCount = this.props.items.length;
    this.carouselInterval = null;

    this.autoPlay = this.autoPlay.bind(this);

    this.clickNavigation = this.clickNavigation.bind(this);
    this.changeSlide = this.changeSlide.bind(this);
    this.windowResize = this.windowResize.bind(this);
    this.doAnimation = false;
  }

  componentDidMount() {
    this.setState({
      innerWidth: window.innerWidth,
    });
    this.autoPlay();
    window.addEventListener('resize', this.windowResize);
    this.preloadImages();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResize);
  }

  componentDidUpdate() {
    if (this.doAnimation) {
      const slide = document.querySelector('.carousel-v2 .content');
      if (slide) {
        slide.classList.remove('show');
        setTimeout(() => slide.classList.add('show'), 0);
      }
    } else {
      this.doAnimation = true;
    }
  }

  render() {
    const { items, routes, isTouch, widgetName } = this.props;

    if (!items.length) {
      return null;
    }

    const { selectedIndex, innerWidth } = this.state;
    const item = items[selectedIndex];

    return h(
      '.carousel-v2',
      {
        'data-bhw': widgetName,
        onMouseEnter: () => this.mouseEnterHandler(),
        onMouseLeave: () => this.mouseLeaveHandler(),
      },
      [
        h(
          '.content.show',
          Slide({
            routes,
            item,
            isTouch,
            sizes: {
              offer: getOfferImageSize(isTouch, innerWidth),
              logo: getLogoImageSize(isTouch),
            },
            innerWidth,
            className: 'carousel-slide',
          })
        ),
        h('.navigation', [this.getPages(), this.getControls()]),
      ]
    );
  }

  getPages() {
    const { selectedIndex, pageNumber } = this.state;
    const { items, isTouch, routes } = this.props;

    const marginTop = 86 * pageNumber * -1;
    if (isTouch) {
      return null;
    }

    const itemsAdjusted = this.getPagesItems(items, selectedIndex);
    return h(
      '.navigation-pages',
      {
        style: `transform: translate(0, ${marginTop}px); margin-top: ${marginTop *
          -1}px;`,
      },
      itemsAdjusted.map((item, index) =>
        Thumbnail({
          item,
          index,
          clickNavigation: this.clickNavigation,
          routes,
        })
      )
    );
  }

  getControls() {
    const { isTouch } = this.props;
    if (isTouch) {
      return [
        h('a.icon.icon-arrow-left-large', {
          'data-bhc': 'carousel-button:next',
          onClick: event => this.clickNavigation(event, false),
        }),
        h('a.icon.icon-arrow-right-large', {
          'data-bhc': 'carousel-button:next',
          onClick: event => this.clickNavigation(event),
        }),
      ];
    }

    return h('a.icon.icon-arrow-down-large', {
      'data-bhc': 'carousel-button:next',
      onClick: event => this.clickNavigation(event),
    });
  }
}

module.exports = CarouselV2;
